import { Component, Input, OnInit } from "@angular/core";
import { ProfileModel } from "src/app/models/profile.model";

@Component({
  selector: "profile-badge",
  templateUrl: "./profile-badge.component.html",
  styleUrls: ["./profile-badge.component.scss"]
})
export class ProfileBadgeComponent implements OnInit {
  @Input()
  object: string;

  @Input()
  status: string;

  @Input()
  disabled: boolean;

  @Input()
  profile: ProfileModel;

  @Input()
  role: string;

  constructor() {
  }

  ngOnInit() {}
}
